import React from 'react';
import Base from './components/Base';
import Login from './components/auth/Login';
import 'bootstrap/dist/css/bootstrap.min.css';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import ProfileAccount from './pages/Account/ProfileAccount';
import ProfileList from './pages/Account/ProfileList';
import ErrorHandlerPage from './pages/ErrorPage/ErrorHandlerPage';
import StationListPage from './pages/Station/ListStations'
import StationDetailsPage from './pages/Station/StationDetails'
import StationDevicesPage from './pages/Station/StationDevices'
function App() {

    return (
        <Router>

            <Routes>
                <Route path="/" element={<Base />}>
                    <Route path="profile" element={<ProfileAccount />} />
                    <Route path="/station_list_page/" element={<StationListPage />} />
                    <Route path="/stations/:serial/" element={<StationDetailsPage />} />
                    <Route path="/devices/:serial/" element={<StationDevicesPage />} />
                </Route>
                <Route path="/login/" element={<Login />} />
                <Route path="/error/" element={<ErrorHandlerPage />} />
                <Route path="*" element={<ErrorHandlerPage />} />

            </Routes>
        </Router>

    );
}

export default App;
